export function setDescription(state, description) {
  state.description = description;
}
export function setAmount(state, amount) {
  state.amount = amount;
}
export function setDistinationUser(state, distinationUser) {
  state.distinationUser = distinationUser;
}
export function setTransaction(state, data) {
  state.transaction = data;
}
export function setSourceAccount(state, account) {
  state.sourceAccount = account;
}
export function setDistinationTransaction(state, result) {
  state.distinationTransaction = result;
}
